import React, { useState, useEffect } from "react";
import {
  TextField,
  Button,
  InputLabel,
  MenuItem,
  FormControl,
  Select,
  FormControlLabel,
  Checkbox,
  FormHelperText,
} from "@mui/material";
import { Formik, Form } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import SuccessModal from "../../../components/Modals/SuccessfulModal.js";
import {
  createProduct,
  updateProductById,
} from "../../../redux/productSlice.js";
import { fetchCategories } from "../../../redux/categoriesSlice.js";
import { AREA_OPTIONS, LANGUAGE_OPTIONS } from "../../constants.js";
import * as Yup from "yup";

const CreateProduct = ({ onSubmit, actionType }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();

  const defaultValues = {
    categoryId: "",
    productLanguages: [{ language: "", value: "" }],
    productName: "",
    weight: "",
    quantity: "",
    amount: "",
    productDescriptionLanguages: [{ language: "", value: "" }],
    productDescription: [""],
    discountedPrice: "",
    productAvailabilityArea: [],
    productImages: [],
    productCoverImage: "",
    isAddons: false,
  };
  console.log(
    "location.state?.productDetails---------->",
    location.state?.productDetails
  );
  const [coverImage, setCoverImage] = useState(null);
  const [coverImageUrl, setCoverImageUrl] = useState("");
  const [productImages, setProductImages] = useState([]);
  const [productImageUrls, setProductImageUrls] = useState([]);
  const [successModalOpen, setSuccessModalOpen] = useState(false);
  const [errorModalOpen, setErrorModelOpen] = useState(false);
  const [imageError, setImageError] = useState("");
  const categoryData = useSelector((state) => state.categories.categoriesData);

  useEffect(() => {
    if (categoryData.length <= 0) dispatch(fetchCategories());
  }, [dispatch]);

  actionType = location.state?.actionType;
  const initialValues =
    actionType === "edit" ? location.state?.productDetails : defaultValues;

  useEffect(() => {
    if (location.state?.productDetails)
      setProductImageUrls(location.state?.productDetails?.productImages);
  }, [location.state?.productDetails]);

  const validationSchema = Yup.object().shape({
    categoryId: Yup.string().required("Category is required"),
    productName: Yup.string().required("Product Name is required"),
    productLanguages: Yup.array().of(
      Yup.object().shape({
        language: Yup.string().required("Language is required"),
        value: Yup.string().required("Value is required"),
      })
    ),
    productDescriptionLanguages: Yup.array().of(
      Yup.object().shape({
        language: Yup.string().required("Language is required"),
        value: Yup.string().required("Value is required"),
      })
    ),
    weight: Yup.number()
      .required("Weight is required")
      .positive("Weight must be positive")
      .typeError("Weight must be a number"),
    quantity: Yup.number()
      .required("Quantity is required")
      .positive("Quantity must be positive")
      .integer("Quantity must be an integer")
      .typeError("Quantity must be a number"),
    amount: Yup.number()
      .required("Amount is required")
      .positive("Amount must be positive")
      .typeError("Amount must be a number"),
    // productDescription: Yup.string().required(
    //   "Product Description is required"
    // ),
    productAvailabilityArea: Yup.array().min(
      1,
      "At least one area is required"
    ),
    discountedPrice: Yup.number()
      .required("Discounted Price is required")
      .positive("Discounted Price must be positive")
      .typeError("Discounted Price must be a number"),
    isAddons: Yup.boolean(),

    // Cover Image validation (ensure file is not empty)
    productCoverImage: Yup.mixed()
      .required("Cover image is required")
      .test("fileSize", "File too large", (value) => {
        return value && value.size <= 2 * 1024 * 1024; // Max size: 2MB
      })
      .test("fileType", "Unsupported file format", (value) => {
        return (
          value &&
          ["image/jpeg", "image/png", "image/jpg", "image/gif"].includes(
            value.type
          )
        );
      })
      .nullable(),

    // Product Images validation (ensure at least one image is uploaded)
    productImages: Yup.array()
      .min(1, "At least one product image is required")
      .of(
        Yup.mixed()
          .required("Product image is required")
          .test("fileSize", "File too large", (value) => {
            return value && value.size <= 2 * 1024 * 1024; // Max size: 2MB
          })
          .test("fileType", "Unsupported file format", (value) => {
            return (
              value &&
              ["image/jpeg", "image/png", "image/jpg", "image/gif"].includes(
                value.type
              )
            );
          })
      )
      .nullable(),
  });
  return (
    <>
      <div>
        {location.state?.actionType === "edit" ? (
          <>
            <h1 className="fprimary">Edit Product</h1>
            <h5>Edit Product Details Carefully</h5>
          </>
        ) : (
          <>
            <h1 className="fprimary">Add Product</h1>
            <h5>Add Product Details</h5>
          </>
        )}
      </div>
      <div className="card mt-3 bg-stage bg-dot">
        <div className="card-body">
          <Formik
            initialValues={initialValues}
            enableReinitialize
            validationSchema={validationSchema}
            onSubmit={(values, { setSubmitting }) => {
              const formData = new FormData();
              formData.append("categoryId", values.categoryId);
              formData.append(
                "productLanguages",
                JSON.stringify(values.productLanguages)
              );
              formData.append(
                "productDescriptionLanguages",
                JSON.stringify(values.productDescriptionLanguages)
              );
              formData.append("productName", values.productName);
              formData.append(
                "discountedPrice",
                parseFloat(values.discountedPrice)
              );
              // formData.append("productDescription", values.productDescription);
                   formData.append(
                     "productDescription",
                     JSON.stringify(values.productDescription)
                   );
              formData.append("weight", parseFloat(values.weight));
              formData.append("quantity", parseFloat(values.quantity));
              formData.append("amount", parseFloat(values.amount));
              formData.append("isAddons", values.isAddons);
              formData.append(
                "productAvailabilityArea",
                JSON.stringify(
                  values.productAvailabilityArea.map((area) => ({
                    type: "Point",
                    coordinates: AREA_OPTIONS.find(
                      (option) => option.name === area
                    ).coordinates,
                  }))
                )
              );

              if (coverImage) {
                formData.append("productCoverImage", coverImage);
              }

              if (productImages && productImages.length > 0) {
                productImages.forEach((image, index) => {
                  formData.append(`productImages`, image); // Add each image to the formData
                });
              }

              // Handle submission differently for edit and create
              if (actionType === "edit") {
                const updatedFormData = {
                  amount: formData.get("amount"),
                  categoryId: formData.get("categoryId"), // TODO -update category part as it cant be array
                  discountedPrice: formData.get("discountedPrice"),
                  isActive: formData.get("isActive"),
                  productAvailabilityArea: formData.get(
                    "productAvailabilityArea"
                  ),
                  productCoverImage: formData.get("productCoverImage"),
                  productDescription: formData.get("productDescription"),
                  productDescriptionLanguages: formData.get(
                    "productDescriptionLanguages"
                  ),
                  productImages: formData.get("productImages"),
                  productName: formData.get("productName"),
                  quantity: formData.get("quantity"),
                  weight: formData.get("weight"),
                };
                dispatch(
                  updateProductById({
                    productId: values._id,
                    productData: updatedFormData,
                  })
                ) // Edit product action
                  .then((data) => {
                    if (!data.payload.isSuccess) {
                      setErrorModelOpen(true);
                      setImageError(
                        data.payload.message || "Something Went Wrong"
                      );
                    } else {
                      setSubmitting(false);
                      setSuccessModalOpen(true);
                    }
                  })
                  .catch((error) => {
                    setImageError(error.message);
                    setSubmitting(false);
                  });
              } else {
                dispatch(createProduct(formData)) // Create product action
                  .then((data) => {
                    if (!data.payload.isSuccess) {
                      setErrorModelOpen(true);
                      setImageError(
                        data.payload.message || "Internal Server Error"
                      );
                    } else {
                      setSubmitting(false);
                      setSuccessModalOpen(true);
                    }
                  })
                  .catch((error) => {
                    setImageError(error.message);
                    setSubmitting(false);
                  });
              }
            }}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldValue,
              isSubmitting,
              setFieldTouched,
            }) => {
              return (
                <Form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-4 cs-form mb-3 mt-3">
                      <FormControl className="md-input" fullWidth>
                        <InputLabel id="category-select-label">
                          Category
                        </InputLabel>
                        <Select
                          labelId="category-select-label"
                          name="categoryId"
                          value={values.categoryId}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={
                            touched.categoryId && Boolean(errors.categoryId)
                          }
                        >
                          {categoryData.length !== 0 ? (
                            categoryData.map((category, i) => (
                              <MenuItem value={category._id}>
                                {category.name}
                              </MenuItem>
                            ))
                          ) : (
                            <MenuItem value="">
                              <em>No Category Available </em>
                            </MenuItem>
                          )}
                        </Select>
                        <FormHelperText>
                          {touched.categoryId && errors.categoryId}
                        </FormHelperText>
                      </FormControl>
                    </div>

                    <div className="col-md-4 cs-form mb-3 mt-3">
                      <TextField
                        name="productName"
                        label="Product Name"
                        value={values.productName}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          touched.productName && Boolean(errors.productName)
                        }
                        helperText={touched.productName && errors.productName}
                        fullWidth
                      />
                    </div>

                    {/* Product Languages */}
                    {values.productLanguages?.map((l, index) => (
                      <div key={index} className="col-md-6 cs-form mb-3 mt-3">
                        <FormControl fullWidth margin="normal">
                          <InputLabel>Product Languages</InputLabel>
                          <Select
                            name={`productLanguages[${index}].language`}
                            value={values.productLanguages[index].language}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={
                              touched.productLanguages &&
                              Boolean(
                                errors.productLanguages?.[index]?.language
                              )
                            }
                          >
                            {LANGUAGE_OPTIONS.map((language) => (
                              <MenuItem
                                key={language.code}
                                value={language.code}
                              >
                                {language.name}
                              </MenuItem>
                            ))}
                          </Select>
                        </FormControl>
                        <TextField
                          label="Value"
                          name={`productLanguages[${index}].value`}
                          value={values.productLanguages[index].value}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={
                            touched.productLanguages &&
                            Boolean(errors.productLanguages?.[index]?.value)
                          }
                          helperText={
                            touched.productLanguages &&
                            errors.productLanguages?.[index]?.value
                          }
                          fullWidth
                          margin="normal"
                        />
                        {index > 0 && (
                          <Button
                            variant="contained"
                            color="error"
                            onClick={() =>
                              setFieldValue(
                                `productLanguages`,
                                values.productLanguages.filter(
                                  (_, i) => i !== index
                                )
                              )
                            }
                          >
                            Remove Translation
                          </Button>
                        )}
                      </div>
                    ))}

                    {/* Add Language Button */}
                    <div className="col-md-12 cs-form mb-3 mt-3">
                      <Button
                        variant="outlined"
                        onClick={() =>
                          setFieldValue("productLanguages", [
                            ...values.productLanguages,
                            { language: "", value: "" },
                          ])
                        }
                      >
                        Add Language
                      </Button>
                    </div>

                    {/* <div className="col-md-4 cs-form mb-3 mt-3">
                      <TextField
                        name="productDescription"
                        label="Product Description"
                        value={values.productDescription}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          touched.productDescription &&
                          Boolean(errors.productDescription)
                        }
                        helperText={
                          touched.productDescription &&
                          errors.productDescription
                        }
                        fullWidth
                      />
                    </div> */}
                    <div className="col-md-12 cs-form mb-3 mt-3">
                      {values.productDescription.map((desc, index) => (
                        <div key={index} className="d-flex align-items-center">
                          <TextField
                            name={`productDescription[${index}]`}
                            label={`Product Description ${index + 1}`}
                            value={desc}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={
                              touched.productDescription &&
                              Boolean(errors.productDescription)
                            }
                            helperText={
                              touched.productDescription &&
                              errors.productDescription
                            }
                            fullWidth
                            margin="normal"
                          />
                          {index > 0 && (
                            <Button
                              variant="contained"
                              color="error"
                              onClick={() =>
                                setFieldValue(
                                  "productDescription",
                                  values.productDescription.filter(
                                    (_, i) => i !== index
                                  )
                                )
                              }
                            >
                              Remove
                            </Button>
                          )}
                        </div>
                      ))}
                    </div>
                    <div className="col-md-12 cs-form mb-3 mt-3">
                      <Button
                        variant="outlined"
                        onClick={() =>
                          setFieldValue("productDescription", [
                            ...values.productDescription,
                            "",
                          ])
                        }
                      >
                        Add More Description
                      </Button>

                      {/* Product Description Languages */}
                      {values.productDescriptionLanguages?.map((l, index) => (
                        <div key={index} className="col-md-6 cs-form mb-3 mt-3">
                          <FormControl fullWidth margin="normal">
                            <InputLabel>
                              Product Description Languages
                            </InputLabel>
                            <Select
                              name={`productDescriptionLanguages[${index}].language`}
                              value={
                                values.productDescriptionLanguages[index]
                                  .language
                              }
                              onChange={handleChange}
                              onBlur={handleBlur}
                              error={
                                touched.productDescriptionLanguages &&
                                Boolean(
                                  errors.productDescriptionLanguages?.[index]
                                    ?.language
                                )
                              }
                            >
                              {LANGUAGE_OPTIONS.map((language) => (
                                <MenuItem
                                  key={language.code}
                                  value={language.code}
                                >
                                  {language.name}
                                </MenuItem>
                              ))}
                            </Select>
                          </FormControl>
                          <TextField
                            label="Value"
                            name={`productDescriptionLanguages[${index}].value`}
                            value={
                              values.productDescriptionLanguages[index].value
                            }
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={
                              touched.productDescriptionLanguages &&
                              Boolean(
                                errors.productDescriptionLanguages?.[index]
                                  ?.value
                              )
                            }
                            helperText={
                              touched.productDescriptionLanguages &&
                              errors.productDescriptionLanguages?.[index]?.value
                            }
                            fullWidth
                            margin="normal"
                          />
                          {index > 0 && (
                            <Button
                              variant="contained"
                              color="error"
                              onClick={() =>
                                setFieldValue(
                                  `productDescriptionLanguages`,
                                  values.productDescriptionLanguages.filter(
                                    (_, i) => i !== index
                                  )
                                )
                              }
                            >
                              Remove Translation
                            </Button>
                          )}
                        </div>
                      ))}
                    </div>

                    {/* Add Description Language Button */}
                    <div className="col-md-12 cs-form mb-3 mt-3">
                      <Button
                        variant="outlined"
                        onClick={() =>
                          setFieldValue("productDescriptionLanguages", [
                            ...values.productDescriptionLanguages,
                            { language: "", value: "" },
                          ])
                        }
                      >
                        Add Description Language
                      </Button>
                    </div>

                    <div className="col-md-4 cs-form mb-3 mt-3">
                      <TextField
                        name="weight"
                        label="Weight"
                        value={values.weight}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.weight && Boolean(errors.weight)}
                        helperText={touched.weight && errors.weight}
                        fullWidth
                      />
                    </div>
                    <div className="col-md-4 cs-form mb-3 mt-3">
                      <TextField
                        name="quantity"
                        label="Quantity"
                        value={values.quantity}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.quantity && Boolean(errors.quantity)}
                        helperText={touched.quantity && errors.quantity}
                        fullWidth
                      />
                    </div>
                    <div className="col-md-4 cs-form mb-3 mt-3">
                      <TextField
                        name="amount"
                        label="Amount"
                        value={values.amount}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={touched.amount && Boolean(errors.amount)}
                        helperText={touched.amount && errors.amount}
                        fullWidth
                      />
                    </div>

                    <div className="col-md-4 cs-form mb-3 mt-3">
                      <FormControl className="md-input" fullWidth>
                        <InputLabel id="product-availability-area-select-label">
                          Product Availability Area
                        </InputLabel>
                        <Select
                          labelId="product-availability-area-select-label"
                          name="productAvailabilityArea"
                          multiple
                          value={values.productAvailabilityArea || []}
                          onChange={handleChange}
                          onBlur={handleBlur}
                          error={
                            touched.productAvailabilityArea &&
                            Boolean(errors.productAvailabilityArea)
                          }
                          renderValue={(selected) => selected.join(", ")}
                        >
                          {AREA_OPTIONS.map((option) => (
                            <MenuItem key={option.name} value={option.name}>
                              {option.name}
                            </MenuItem>
                          ))}
                        </Select>
                        <FormHelperText>
                          {touched.productAvailabilityArea &&
                            errors.productAvailabilityArea}
                        </FormHelperText>
                      </FormControl>
                    </div>

                    <div className="col-md-4 cs-form mb-3 mt-3">
                      <TextField
                        name="discountedPrice"
                        label="Discounted Price"
                        value={values.discountedPrice}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={
                          touched.discountedPrice &&
                          Boolean(errors.discountedPrice)
                        }
                        helperText={
                          touched.discountedPrice && errors.discountedPrice
                        }
                        fullWidth
                      />
                    </div>
                    <div className="col-md-4 cs-form mb-3 mt-3">
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={values.isAddons}
                            onChange={handleChange}
                            name="isAddons"
                            color="primary"
                          />
                        }
                        label="Is Addons"
                      />
                    </div>
                    <div className="col-md-12 cs-form mb-3">
                      <div className="banner_padding">
                        <p className="banner_heading_text">Cover Image</p>
                        <input
                          type="file"
                          onChange={(event) => {
                            const file = event.target.files[0];
                            if (file) {
                              setFieldValue("productCoverImage", file); // Update Formik's value
                              setCoverImage(file);
                              setCoverImageUrl(URL.createObjectURL(file));
                            }
                          }}
                          onBlur={() =>
                            setFieldTouched("productCoverImage", true)
                          }
                        />

                        <img
                          src={
                            coverImageUrl
                              ? coverImageUrl
                              : values.productCoverImage
                          }
                          accept="image/*"
                          alt="Cover"
                          style={{
                            width: "80px",
                            height: "68px",
                            borderRadius: "12px",
                            marginLeft: "10px",
                            marginRight: "25px",
                          }}
                        />

                        {touched.productCoverImage &&
                          errors.productCoverImage && (
                            <div className="text-warning">
                              {errors.productCoverImage}
                            </div>
                          )}
                      </div>
                    </div>
                    <div className="col-md-12 cs-form mb-3">
                      <div className="banner_padding">
                        <p className="banner_heading_text">Product Images</p>
                        <input
                          type="file"
                          multiple
                          onChange={(event) => {
                            const files = Array.from(event.target.files);

                            console.log("------ cover image before -", files);

                            if (files.length) {
                              console.log(
                                "------ cover image in the if -",
                                files
                              );
                              setFieldValue("productImages", files); // Update Formik's value
                              setProductImages(files);
                              setProductImageUrls(
                                files.map((file) => URL.createObjectURL(file))
                              );
                            }
                          }}
                          onBlur={() => setFieldTouched("productImages", true)} // Mark as touched on blur
                        />
                        <div className="d-flex flex-wrap">
                          {productImageUrls.map((url, index) => (
                            <img
                              key={index}
                              src={url}
                              accept="image/*"
                              alt={`Product ${index + 1}`}
                              style={{
                                width: "80px",
                                height: "68px",
                                borderRadius: "12px",
                                marginLeft: "10px",
                                marginRight: "25px",
                              }}
                            />
                          ))}
                        </div>
                        {/* Display product images error  */}
                        {errors.productImages && (
                          <div className="text-warning">
                            {errors.productImages}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className="d-flex justify-content-between mt-3 mb-3">
                      <button
                        type="button"
                        className="btn btn-light grey-btn lg-btn"
                        onClick={() => navigate(-1)}
                      >
                        {t("createOrder.back")}
                      </button>
                      <button
                        type="submit"
                        className="btn btn-primary greeen-btn lg-btn"
                        disabled={isSubmitting}
                      >
                        {actionType === "edit" ? t("Update") : t("Submit")}
                      </button>
                    </div>
                  </div>
                </Form>
              );
            }}
          </Formik>
          {successModalOpen && (
            <SuccessModal
              isOpen={successModalOpen}
              msg={
                actionType === "edit"
                  ? t("Product successfully updated")
                  : t("Product successfully created")
              }
              navigatePage={"/products"}
            />
          )}
          {errorModalOpen && (
            <SuccessModal
              isOpen={errorModalOpen}
              msg={imageError}
              type="error"
            />
          )}
        </div>
      </div>
    </>
  );
};

export default CreateProduct;
